'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'

/**
 * Clears signup_return_url from localStorage when user successfully lands on their intended page
 * This runs once when the user is authenticated and on any page
 */
export default function SignupSuccessHandler() {
  const { data: session, status } = useSession()

  useEffect(() => {
    // Only run when session is loaded and user is authenticated
    if (status === 'loading') return

    if (session?.user) {
      try {
        const signupReturnUrl = localStorage.getItem('signup_return_url')

        if (signupReturnUrl) {
          // Check if we're on the intended page
          const currentUrl = window.location.href
          if (currentUrl === signupReturnUrl) {
            // Success! User is on their intended page, clear the stored URL
            localStorage.removeItem('signup_return_url')
            // Debug logging (remove in production)
            if (process.env.NODE_ENV === 'development') {
              console.log('✅ Signup flow complete! Cleared signup_return_url')
            }
          }
        }
      } catch (error) {
        // Silently handle localStorage errors (e.g., in incognito mode)
        console.warn('SignupSuccessHandler: localStorage error', error)
      }
    }
  }, [session, status])

  return null // This component doesn't render anything
}
